import "./aboutUs";
import "./banner";
import "./advert";
import "./slidenav";
import "./contactUs";
import "./innerAboutUs";
import "./navigation";
import "./news";
import "./topicpost";
import "./product";
import "./productCategory";
import "./mobileSearchBox";
import "@/pages/base/divUtils";
import {loadContact} from "@/phone";
$(function () {
    loadContact();
});
